<template>
<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="18"
   height="18"
   viewBox="0 0 4.7624998 4.7625001"
   version="1.1"
   id="svg3892"
   fill="currentColor"
   class="bi bi-admin"
>
  <defs
     id="defs3886" />
  <g
     id="layer1"
     transform="translate(0,-292.23749)">
    <path
       d="m 1.0725075,296.77202 c 0,0 -0.26458341,0 -0.26458341,-0.25326 0,-0.25327 0.26458341,-1.01306 1.58750011,-1.01306 1.3229167,0 1.5875,0.75979 1.5875,1.01306 0,0.25326 -0.2645833,0.25326 -0.2645833,0.25326 z m 1.3229167,-1.51958 a 0.79375393,0.759795 0 1 0 0,-1.51959 0.79375393,0.759795 0 0 0 0,1.51959 z"
       id="path3816"
       style="stroke-width:0.25886169" />
    <path
       d="m 2.3965467,293.70851 a 0.8588375,0.8588375 0 1 0 0,1.71767 0.8588375,0.8588375 0 0 0 0,-1.71767 z m -0.5942542,0.85883 a 0.5942542,0.5942542 0 1 1 1.1885084,0 0.5942542,0.5942542 0 0 1 -1.1885084,0 z"
       id="path3763"
       style="stroke-width:0.26458335" />
    <path
       d="m 2.8717384,292.80601 c -0.1394355,-0.4736 -0.810948,-0.4736 -0.9503834,0 l -0.024871,0.0844 a 0.23098125,0.23098125 0 0 1 -0.3320521,0.13758 l -0.077258,-0.0423 c -0.4339168,-0.23601 -0.90831468,0.23865 -0.67204181,0.6723 l 0.042069,0.0773 a 0.23098125,0.23098125 0 0 1 -0.13758329,0.33205 l -0.0844021,0.0249 c -0.47360417,0.13944 -0.47360417,0.81095 0,0.95039 l 0.0844021,0.0249 a 0.23098125,0.23098125 0 0 1 0.13758329,0.33205 l -0.042333,0.0773 c -0.23600829,0.43391 0.23838961,0.90858 0.67230641,0.67204 l 0.077258,-0.0421 a 0.23098125,0.23098125 0 0 1 0.3320521,0.13758 l 0.024871,0.0844 c 0.1394354,0.4736 0.8109479,0.4736 0.9503834,0 l 0.024871,-0.0844 a 0.23098125,0.23098125 0 0 1 0.3320521,-0.13758 l 0.077258,0.0423 c 0.4339167,0.23628 0.9085792,-0.23865 0.6720417,-0.6723 l -0.042069,-0.0773 a 0.23098125,0.23098125 0 0 1 0.1375834,-0.33205 l 0.084402,-0.0249 c 0.4736042,-0.13944 0.4736042,-0.81095 0,-0.95039 l -0.084402,-0.0249 a 0.23098125,0.23098125 0 0 1 -0.1375834,-0.33205 l 0.042333,-0.0773 c 0.2362729,-0.43392 -0.2386542,-0.90831 -0.6723063,-0.67204 l -0.077258,0.0421 a 0.23098125,0.23098125 0 0 1 -0.3320521,-0.13758 z m -0.696648,0.0749 c 0.065087,-0.22093 0.377825,-0.22093 0.4429125,0 l 0.024871,0.0844 a 0.49556459,0.49556459 0 0 0 0.7125229,0.29501 l 0.076994,-0.0423 c 0.2021417,-0.1098 0.4233334,0.11112 0.3132667,0.31353 l -0.042069,0.0773 a 0.49556459,0.49556459 0 0 0 0.295275,0.71226 l 0.084137,0.0249 c 0.220927,0.0651 0.220927,0.37782 0,0.44291 l -0.084402,0.0249 a 0.49556459,0.49556459 0 0 0 -0.2950104,0.71252 l 0.042333,0.077 c 0.1098021,0.20214 -0.111125,0.42333 -0.3135313,0.31326 l -0.076994,-0.0421 a 0.49556459,0.49556459 0 0 0 -0.7125229,0.29527 l -0.024871,0.0841 c -0.065087,0.22093 -0.377825,0.22093 -0.4429125,0 l -0.024871,-0.0844 a 0.49556459,0.49556459 0 0 0 -0.7122571,-0.29508 l -0.077258,0.0423 c -0.2021417,0.1098 -0.42333341,-0.11113 -0.3132667,-0.31353 l 0.042069,-0.077 a 0.49556459,0.49556459 0 0 0 -0.29501041,-0.71278 l -0.0844021,-0.0249 c -0.22092708,-0.0651 -0.22092708,-0.37783 0,-0.44292 l 0.0844021,-0.0249 a 0.49556459,0.49556459 0 0 0 0.29501041,-0.71199 l -0.042333,-0.0773 c -0.10980211,-0.20214 0.111125,-0.42333 0.3135313,-0.31327 l 0.077258,0.0421 a 0.49556459,0.49556459 0 0 0 0.7122583,-0.29501 z"
       id="path3765"
       style="stroke-width:0.26458335" />
  </g>
</svg>
</template>

<script>
// Based on joining:
// https://icons.getbootstrap.com/icons/gear/
// https://icons.getbootstrap.com/icons/person-fill/
export default {
name: "Admin"
}
</script>

<style>

</style>